import { NotificationService } from './notification.service';
import { NotificationModule } from './notification.module';

export {
  NotificationService,
  NotificationModule
};
